export default __webpack_public_path__ + "static/media/Btn_FullHD.8696be22.png";